import React from 'react';

import OAuthButtons from '@components/OAuthButtons';
import ExpandableOAuthButtons from '@components/OAuthButtons/ExpandableOAuthButtons';
import { LeadType } from '@utils/types';

interface OAuthOptionProps {
  articleId: number;
  briefingGuid?: string;
  expandable: boolean;
  expandableOathButtonsClassName?: string;
  isGdprOptIn: boolean;
  isVertical: boolean;
  leadType: LeadType;
  newsletterIds: number[];
  oauthButtonsClassName: string;
  redirectToOnSuccess: string;
  shareGuid: string;
  unlockContent: boolean;
}

const OAuthOption = ({
  articleId,
  briefingGuid,
  expandableOathButtonsClassName,
  expandable,
  isGdprOptIn,
  leadType,
  isVertical,
  newsletterIds,
  oauthButtonsClassName,
  redirectToOnSuccess,
  shareGuid,
  unlockContent,
}: OAuthOptionProps) => {
  return (
    <>
      {expandable ? (
        <ExpandableOAuthButtons
          articleId={articleId}
          briefingGuid={briefingGuid}
          isGdprOptIn={isGdprOptIn}
          leadType={leadType}
          newsletterIds={newsletterIds}
          oauthButtonsClassName={oauthButtonsClassName}
          redirectToOnSuccess={redirectToOnSuccess}
          shareGuid={shareGuid}
          unlockContent={unlockContent}
          className={expandableOathButtonsClassName}
        />
      ) : (
        <OAuthButtons
          articleId={articleId}
          briefingGuid={briefingGuid}
          buttonWidth={isVertical ? 100 : 250}
          isGdprOptIn={isGdprOptIn}
          leadType={leadType}
          newsletterIds={newsletterIds}
          oauthButtonsClassName={oauthButtonsClassName}
          redirectToOnSuccess={redirectToOnSuccess}
          shareGuid={shareGuid}
          unlockContent={unlockContent}
        />
      )}
    </>
  );
};

export default OAuthOption;
